import Moment from 'moment';
import map from 'lodash/map';
import find from 'lodash/find';
import some from 'lodash/some';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
import orderBy from 'lodash/orderBy';
import * as urls from '../actions/urlTypes';
import IconTarget from '../components/enablement/shared/icons/IconTarget';
import IconBuild from '../components/enablement/shared/icons/IconBuild';
import IconDistribute from '../components/enablement/shared/icons/IconDistribute';
import IconLabel from '../components/enablement/shared/icons/IconLabel';
import {
  LOW_SAMPLE_WEIGHTED_MSG,
  MORE_STUDY_AVAILABLE_MSG,
} from '../components/enablement/shared/DEConstants';
import { getLabel } from './autocodeUtils';

import AutocodeLabelsGenerator, {
  ACStandardLabels,
} from '../components/autocode/AutocodeLabelsGenerator';

const { toLabelString } = AutocodeLabelsGenerator(ACStandardLabels, null);

export const _navItems = [
  {
    id: 'deTargets',
    title: 'Targets',
    icon: IconTarget,
    isActive: false,
    path: `${urls.APP_ROOT_URL}/datahub/targets`,
  },
  {
    id: 'deBuild',
    title: 'Build',
    icon: IconBuild,
    isActive: false,
    path: `${urls.APP_ROOT_URL}/datahub/build`,
  },
  {
    id: 'deLabel',
    title: 'Label',
    icon: IconLabel,
    isActive: false,
    path: `${urls.APP_ROOT_URL}/datahub/label`,
  },
  {
    id: 'deDistribute',
    title: 'Destinations',
    icon: IconDistribute,
    isActive: false,
    path: `${urls.APP_ROOT_URL}/datahub/distribute`,
  },
];

// export const _getActiveLeftNav = currentNav => {
//   return _navItems.map(nav => ({ ...nav, isActive: nav.id === currentNav }));
// };

export const _getDefinitionData = (data = [], isChangeWeight) => {
  let uiData = [...data];
  if (!isChangeWeight) {
    uiData = data.map(item => {
      return { ...item, isActive: false };
    });
  }

  return uiData;
};

export const _setActiveDefinaction = (
  data,
  isSelected,
  row = null,
  isAll = false
) => {
  const uiData = data.map(item => {
    let isActive = false;

    if (row) {
      // toggle active on checkbox checked
      if (row.id === item.id) {
        isActive = isSelected;
      }
    }

    if (isAll) {
      isActive = isSelected;
    }

    // if (isSelectAll) {
    //   // active all when selectall selected
    //   isActive = isSelected
    // };
    return { ...item, isActive };
  });
  return uiData;
};

export const _setActiveDefinitionExp = (
  definition,
  isSelected,
  row = null,
  isAll
) => {
  const definitionExpList = definition.data.map(item => {
    let isActive = item.isActive;
    if (row) {
      // toggle active on checkbox checked
      if (row.ui === item.ui) {
        isActive = isSelected;
      }
    }

    if (isAll && !item.isDisabled) {
      isActive = isSelected;
    }
    return { ...item, isActive };
  });
  return {
    ...definition,
    data: definitionExpList,
  };
};

export const _getDistributionReqLabel = id => {
  const labelName = ['No', 'Yes', 'Completed'];
  return labelName[id];
};

export const _getCheckedDefination = (data = [], flag = 'isActive') => {
  return data.filter(item => item[flag]);
};

// data for study targete
export const _getStudyTargetData = (data = [], pn, wt, isChangeWeight) => {
  if (data.length === 0) {
    return [];
  }

  /** const sortedData = data.sort((a,b) =>
   * new Moment(b.lastModified).format('YYYYMMDD') - new Moment(a.lastModified).format('YYYYMMDD')) */
  const sortedData = orderBy(
    data,
    o => {
      return Moment(o.lastModified).format('YYYYMMDD');
    },
    ['desc']
  );

  const sData = sortedData.map(item => {
    const name = item.lb || item.folderName;
    const sc = item.sc || item.scope;
    const id = item.id || item.definitionId;
    const el = item.el || item.expressions;
    let type = 'G';
    if (sc === 2 || sc === 3 || sc === 6) {
      type = 'S';
    } else if (sc === 4 || sc === 5) {
      type = 'P';
    }
    const d = {
      ...item,
      uniqueId: `${pn}_${wt}_${id}`,
      id,
      type,
      name,
      el,
    };
    return d;
  });
  return _getDefinitionData(sData, isChangeWeight);
};

export const _getStudyTargetGroupedData = data => {
  const obj = {
    personal: [],
    shared: [],
    global: [],
  };

  if (data.length > 0) {
    data.map(item => {
      if (item.type === 'P') {
        obj.personal = [...obj.personal, item];
      }

      if (item.type === 'S') {
        obj.shared = [...obj.shared, item];
      }

      if (item.type === 'G') {
        obj.global = [...obj.global, item];
      }

      return false;
    });
  }
  return obj;
};

export const _setActiveTargets = (data, row) => {
  return data.map(item => {
    let isActive = false;
    if (item.id === row.id) {
      isActive = true;
    }
    return {
      ...item,
      isActive,
    };
  });
};

export const _getLatestStudies = (studies = []) => {
  let latestStudy = null;
  if (studies.length > 0) {
    studies.map(study => {
      if (study.dsti > 0) {
        latestStudy = study.sl.find(s => s.pn === study.dsti);
      }
      return null;
    });
  }
  return latestStudy;
};

export const _checkIfLatestStudyAvailable = (study, studies) => {
  let latestofStudyType;
  for (let i = 0; i < studies.length; i += 1) {
    if (studies[i].sl) {
      const latestStudy = studies[i].sl.find(item => item.sti === study.sti);
      if (latestStudy) {
        latestofStudyType = latestStudy;
        break;
      }
    }
  }
  return latestofStudyType.pn === study.pn;
};

export const _getSampleWeightedParams = async (
  definitionList,
  study,
  accountId,
  userId,
  selectedWeightType
) => {
  let sampleWeightedParams = {};
  const keywordArr = [];
  definitionList.forEach(def => {
    keywordArr.push(def.expression);
  });
  sampleWeightedParams = {
    accountId,
    divisor: selectedWeightType ? selectedWeightType.dv : study.dv,
    expressionList: keywordArr,
    productNo: study.pn,
    uid: userId,
    weightType: selectedWeightType ? selectedWeightType.wt : study.wt,
  };

  return sampleWeightedParams;
};

export const _getFormattedDefinitionsListWithSampleWt = (
  definitionList,
  sampleWeightedList,
  study,
  folder
) => {
  const studyWeightSelected = study.cw.find(
    weightType => weightType.wt === study.wt
  );
  const studyWeight = studyWeightSelected && studyWeightSelected.wn;
  const defFolderId = folder.id;
  const mapppedDefList = map(definitionList, (def, index) => {
    const isDisabled = !sampleWeightedList[index];
    // || !sampleWeightedList[index].intab;
    const sample = sampleWeightedList[index]
      ? sampleWeightedList[index].intab
      : null;
    const weighted = sampleWeightedList[index]
      ? sampleWeightedList[index].weighted
      : null;
    const finalObj = {
      ui: `${study.pn}_${study.wt}_${defFolderId}_${def.expressionId}`,
      di: defFolderId,
      ei: def.expressionId,
      tn: def.title,
      ss: sample,
      weighted,
      pct: sampleWeightedList[index] && sampleWeightedList[index].pct * 100,
      ex: def.expression,
      isActive: false,
      isDisabled,
      sn: `${study.sd} ${studyWeight}`,
      pn: study.pn,
      wt: study.wt,
      dist: 2,
      div: study.dv,
    };
    return finalObj;
  });
  const isThreshold = some(mapppedDefList, def => def.ss && def.ss < 1000);
  const folderExpressionsMappedObj = {
    id: defFolderId,
    // name: definitionListObj[0].lb,
    data: mapppedDefList,
    isThreshold,
  };
  return {
    formatttedObj: folderExpressionsMappedObj,
    folderId: defFolderId,
  };
};

export const _updateSelectedDefList = (
  row,
  isSelected,
  isAll,
  currentSelected,
  selectedData
) => {
  let updatedSelectedList = [];
  if (row) {
    if (!isSelected) {
      updatedSelectedList = selectedData.filter(def => def.ui !== row.ui);
    } else {
      row.originalTn = row.tn;
      row.ct = new Date();
      updatedSelectedList = [row, ...selectedData];
    }
  } else if (isSelected && isAll) {
    const updatedSelectedListTemp = [];
    currentSelected.forEach(def => {
      def.originalTn = def.tn;
      def.ct = new Date();
      updatedSelectedListTemp.push(def);
    });
    updatedSelectedList = [...updatedSelectedListTemp, ...selectedData];
  } else {
    selectedData.forEach(def => {
      if (currentSelected.findIndex(elem => elem.ui === def.ui) === -1)
        def.originalTn = def.tn;
      updatedSelectedList.push(def);
    });
    currentSelected.forEach(target => {
      const targetIndex = findIndex(
        updatedSelectedList,
        item => item.ui === target.ui
      );
      if (targetIndex > -1) {
        updatedSelectedList.splice(targetIndex, 1);
      }
    });
  }
  return updatedSelectedList;
};

export const _checkDuplicateTarget = (targetList, targetRow) => {
  const duplicateTarget = targetList.filter(
    row =>
      row.tn.toLowerCase() === targetRow.tn.toLowerCase() &&
      row.wt === targetRow.wt &&
      row.pn === targetRow.pn &&
      row.ui !== targetRow.ui
  );
  return duplicateTarget;
};

export const _updateValidationList = (
  isSelected,
  selectedList,
  importValidations,
  folderId,
  allTargets,
  isAll
) => {
  const importValidationFolder = importValidations[folderId];
  const tempAllTargets = cloneDeep(allTargets);
  let selectedIds;
  if (selectedList.constructor !== Array) {
    selectedIds = [selectedList.ui];
  } else {
    selectedIds = map(selectedList, elem => elem.ui);
  }
  if (importValidationFolder) {
    const validIds = cloneDeep(importValidationFolder.valid);
    const errors = cloneDeep(importValidationFolder.errors);
    const duplicateTargetList = cloneDeep(
      importValidationFolder.duplicateTargetList
    );
    if (isSelected) {
      if (!isAll) {
        const checkDuplicateTarget = _checkDuplicateTarget(
          tempAllTargets,
          selectedList
        );
        if (checkDuplicateTarget.length > 0) {
          if (validIds.indexOf(selectedList.ui) > -1) {
            validIds.splice(validIds.indexOf(selectedList.ui), 1);
          }
          if (errors.indexOf(selectedList.ui) === -1) {
            errors.push(selectedList.ui);
          }
          if (selectedIds.indexOf(selectedList.ui) > -1) {
            selectedIds.splice(validIds.indexOf(selectedList.ui), 1);
          }
        }
      }
      return {
        errors: [...errors],
        valid: [...validIds, ...selectedIds],
        duplicateTargetList,
      };
    }
    selectedIds.forEach(def => {
      if (validIds.indexOf(def) > -1) {
        validIds.splice(validIds.indexOf(def), 1);
      }
      if (errors.indexOf(def) > -1) {
        errors.splice(errors.indexOf(def), 1);
      }
      if (duplicateTargetList.indexOf(def) > -1) {
        duplicateTargetList.splice(duplicateTargetList.indexOf(def), 1);
      }
      const targetIndex = findIndex(tempAllTargets, item => item.ui === def);
      if (targetIndex > -1) {
        tempAllTargets.splice(targetIndex, 1);
      }
    });
    const duplicateTarget = {};
    tempAllTargets.forEach(item => {
      duplicateTarget[item.ui] = [];
      const tempArr = tempAllTargets.filter(
        row =>
          row.tn.toLowerCase() === item.tn.toLowerCase() &&
          row.wt === item.wt &&
          row.pn === item.pn &&
          row.ui !== item.ui
      );
      duplicateTarget[item.ui] = tempArr;
    });
    const folderIdArr = tempAllTargets.filter(row => row.di === folderId);
    Object.keys(duplicateTarget).forEach(key => {
      if (duplicateTarget[key].length === 0) {
        const folderIdIndex = findIndex(folderIdArr, item => item.ui === key);
        if (
          errors.indexOf(key) > -1 &&
          duplicateTargetList.indexOf(key) === -1 &&
          folderIdIndex > -1
        ) {
          errors.splice(errors.indexOf(key), 1);
        }
        if (
          validIds.indexOf(key) === -1 &&
          duplicateTargetList.indexOf(key) === -1 &&
          folderIdIndex > -1
        ) {
          validIds.push(key);
        }
      }
    });
    return {
      errors: [...errors],
      valid: validIds,
      duplicateTargetList,
    };
  }
  return {
    errors: [],
    valid: selectedIds,
    duplicateTargetList: [],
  };
};

export const getWarnings = (folder, isLatestStudy) => {
  const warningList = [];
  if (folder && folder.isThreshold && !isLatestStudy) {
    warningList.push(LOW_SAMPLE_WEIGHTED_MSG);
    warningList.push(MORE_STUDY_AVAILABLE_MSG);
  } else if (folder && folder.isThreshold) {
    warningList.push(LOW_SAMPLE_WEIGHTED_MSG);
  } else if (folder && !isLatestStudy) {
    warningList.push(MORE_STUDY_AVAILABLE_MSG);
  }
  return warningList;
};

export const _getFormattedTargetList = (data, partsToShow, idFlag) => {
  return map(data, elem => ({
    ui: elem.ui,
    tn:
      partsToShow && Object.keys(partsToShow).length > 0
        ? getLabel(elem, partsToShow)
        : elem.tn,
    dist: elem.dist,
    di: elem.di,
    ei: elem.ei,
    ex: elem.ex,
    pct: elem.pct,
    ss: idFlag && elem.sample ? elem.sample : elem.ss,
    weighted: elem.weighted,
    wt: elem.wt,
    pn: elem.pn,
    sn: elem.sn,
    div: elem.div,
    tags: elem.tags || [],
    id: idFlag && elem.id ? elem.id : undefined,
    ct: elem.ct,
  }));
};

export const _validateTargetLabel = (
  responseData,
  importValidations,
  folderId,
  originalList
) => {
  let selectedFolderErrorData = cloneDeep(importValidations[folderId].errors);
  let selectedFolderValidData = cloneDeep(importValidations[folderId].valid);
  let duplicateTargetList = cloneDeep(
    importValidations[folderId].duplicateTargetList
  );
  if (responseData[0].success && !responseData[0].isDuplicate) {
    if (!selectedFolderValidData.includes(responseData[0].ui)) {
      selectedFolderValidData = [
        ...selectedFolderValidData,
        responseData[0].ui,
      ];
    }
    if (selectedFolderErrorData.includes(responseData[0].ui)) {
      selectedFolderErrorData = selectedFolderErrorData.filter(
        def => def !== responseData[0].ui
      );
    }
    if (duplicateTargetList.includes(responseData[0].ui)) {
      duplicateTargetList = duplicateTargetList.filter(
        def => def !== responseData[0].ui
      );
    }
  } else {
    if (!selectedFolderErrorData.includes(responseData[0].ui)) {
      selectedFolderErrorData = [
        ...selectedFolderErrorData,
        responseData[0].ui,
      ];
    }
    if (selectedFolderValidData.includes(responseData[0].ui)) {
      selectedFolderValidData = selectedFolderValidData.filter(
        def => def !== responseData[0].ui
      );
    }
  }
  if (
    !responseData[0].success &&
    !duplicateTargetList.includes(responseData[0].ui)
  ) {
    duplicateTargetList = [...duplicateTargetList, responseData[0].ui];
  }
  const selectedList = cloneDeep(originalList);
  const targetIndex = findIndex(
    selectedList,
    def => def.ui === responseData[0].ui
  );
  Object.assign(selectedList[targetIndex], { tn: responseData[0].tn });

  return {
    selectedList,
    errors: selectedFolderErrorData,
    valid: selectedFolderValidData,
    duplicateTargetList,
  };
};

export const _getUpdatedListForSave = (selectedList, importValidations) => {
  const finalListForSave = [];
  selectedList.forEach(target => {
    Object.keys(importValidations).forEach(folder => {
      if (importValidations[folder].valid.includes(target.ui)) {
        finalListForSave.push(target);
      }
    });
  });
  return finalListForSave;
};

export const _updateAfterSave = (
  responseData,
  orgininalList,
  importValidations,
  available
) => {
  const validIds = responseData.filter(target => target.success === 1);
  const selectedList = orgininalList.filter(target => {
    return !validIds.map(def => def.ui).includes(target.ui);
  });
  const tempImportValidations = cloneDeep(importValidations);
  responseData.forEach(target => {
    if (tempImportValidations[target.di].valid.includes(target.ui)) {
      tempImportValidations[target.di].valid = tempImportValidations[
        target.di
      ].valid.filter(def => def !== target.ui);
    }
    if (target.success) {
      if (tempImportValidations[target.di].errors.includes(target.ui)) {
        tempImportValidations[target.di].errors = tempImportValidations[
          target.di
        ].errors.filter(def => def !== target.ui);
      }
      if (
        tempImportValidations[target.di].duplicateTargetList.includes(target.ui)
      ) {
        tempImportValidations[
          target.di
        ].duplicateTargetList = tempImportValidations[
          target.di
        ].duplicateTargetList.filter(def => def !== target.ui);
      }
    } else {
      if (!tempImportValidations[target.di].errors.includes(target.ui)) {
        tempImportValidations[target.di].errors = [
          ...tempImportValidations[target.di].errors,
          target.ui,
        ];
      }
      if (
        !tempImportValidations[target.di].duplicateTargetList.includes(
          target.ui
        )
      ) {
        tempImportValidations[target.di].duplicateTargetList = [
          ...tempImportValidations[target.di].duplicateTargetList,
          target.ui,
        ];
      }
    }
  });
  const tempAvailable = cloneDeep(available);
  validIds.forEach(target => {
    const selectedFolderData =
      tempAvailable[`${target.pn}_${target.wt}_${target.di}`];
    const updatedObject = _setActiveDefinitionExp(
      selectedFolderData,
      false,
      target,
      false
    );
    tempAvailable[`${target.pn}_${target.wt}_${target.di}`] = updatedObject;
  });
  return {
    data: selectedList,
    importValidations: {
      ...tempImportValidations,
    },
    hasSuccess: validIds.length,
    available: tempAvailable,
  };
};

export const _updateTargetLabelsExp = (originalTargetExp, updatedLabel) => {
  const tempLabelExp = cloneDeep(originalTargetExp);
  const labelIndex = findIndex(
    tempLabelExp,
    label => label.id === updatedLabel.id
  );
  Object.assign(tempLabelExp[labelIndex], { tl: updatedLabel.tl });
  return tempLabelExp;
};

export const _distReqDupliCheck = (distReqArr = [], distCampArr = []) => {
  let finArr = [];
  if (distReqArr.requestId !== '') {
    distCampArr = distCampArr.filter(
      distReq => distReq.id !== distReqArr.requestId
    );
    finArr = distCampArr.filter(
      camp =>
        camp.campName.trim().toLowerCase() ===
        distReqArr.name.trim().toLowerCase()
    );
    return finArr.length;
  }
  finArr = distCampArr.filter(
    camp =>
      camp.campName.trim().toLowerCase() ===
      distReqArr.name.trim().toLowerCase()
  );
  return finArr.length;
};

export const _distFormatCamp = (distReqArr = {}, targetId = '') => {
  const finalRequest = {
    campName: distReqArr.name,
    actFlag: distReqArr.isForActivation ? 'Y' : 'N',
    strtDt: distReqArr.startDate,
    endDt: distReqArr.endDate,
    targId: targetId,
    dest: distReqArr.dest,
  };
  return finalRequest;
};

export const _sortCampaignList = (campainList = []) => {
  return campainList.sort((a, b) => new Date(b.ut) - new Date(a.ut));
};

export const _getCampaignStatus = statusId => {
  const statusList = {
    0: 'Draft',
    1: 'Submitted',
    2: 'Processing',
    3: 'Approval Required',
    4: 'Active',
    5: 'Deactivated',
    6: 'Cancelled',
  };
  return statusList[statusId];
};

export const formatCampaignDetails = data => {
  const formattedData = {
    name: data.campName,
    isForActivation: data.actFlag === 'Y',
    startDate: data.strtDt,
    endDate: data.endDt,
    targetId: data.targId,
    status: _getCampaignStatus(data.status),
    requestId: data.id,
    dest: data.dest,
    jiraId: data.jiraId,
  };
  return formattedData;
};

export const _checkUnsavedChanges = (distRequest, distributeData) => {
  const { startDate, endDate, name, isForActivation } = distRequest;
  let hasUnsavedData =
    startDate || endDate || name || distRequest.dest.length > 0;

  if (distRequest.requestId) {
    const getOriginalData = distributeData.data.find(
      item => item.id === distRequest.requestId
    );
    const savedDestIds = distRequest.dest.map(item => item.id).sort();
    let isNameEqual;
    let isActFlagEqual;
    let isSDateEqual;
    let isEDateEqual;
    let isDestEqual;
    let isDestinationChanged;
    if (getOriginalData) {
      const { campName, strtDt, endDt, actFlag, dest } = getOriginalData;
      const actFlagToBool = actFlag === 'Y';
      const sDate = Moment(strtDt).format('YYYY/MM/DD');
      const eDate = Moment(endDt).format('YYYY/MM/DD');

      const nSDate = Moment(startDate).format('YYYY/MM/DD');
      const nEDate = Moment(endDate).format('YYYY/MM/DD');

      isNameEqual = campName === name;
      isActFlagEqual = actFlagToBool === isForActivation;
      isSDateEqual = sDate === nSDate;
      isEDateEqual = eDate === nEDate;
      const originalDestIds = dest.map(item => item.id).sort();

      isDestEqual = isEqual(savedDestIds, originalDestIds);

      const destAttrCheckArr = [];
      distRequest.dest.forEach(item => {
        const partner = find(dest, elem => elem.id === item.id);
        if (partner) {
          destAttrCheckArr.push(isEqual(item.attributes, partner.attributes));
        }
      });
      isDestinationChanged = destAttrCheckArr.includes(false);
    }

    hasUnsavedData =
      !isNameEqual ||
      !isActFlagEqual ||
      !isSDateEqual ||
      !isEDateEqual ||
      !isDestEqual ||
      isDestinationChanged;
  }
  return hasUnsavedData;
};

export const _createTargetUniqueID = (node, partsToShow, pn, wn) => {
  const labels = toLabelString(node, partsToShow);
  return `${pn}_${labels}_${wn}`;
};

export const _setTargetNode = (
  payload,
  expression,
  study,
  tn,
  selectedWeightType,
  autocodenode,
  uniqueId
) => {
  const targetData = expression.map((exp, index) => {
    let weightedVal = payload[index];
    if (weightedVal === null) {
      weightedVal = {};
      weightedVal.pct = 0;
      weightedVal.weighted = 0;
      weightedVal.intab = 0;
      weightedVal.modeled = false;
    }
    return {
      pct: weightedVal.pct,
      weighted: Math.round(weightedVal.weighted),
      sample: Math.round(weightedVal.intab),
      ex: exp,
      pn: study.pn,
      wt: selectedWeightType.wt,
      div: selectedWeightType.dv,
      // eslint-disable-next-line radix
      ss: parseInt(study.st),
      sn: `${study.sd} ${selectedWeightType.wn}`,
      isActive: false,
      isDisabled: false,
      tn,
      ui: uniqueId,
      originalTitle: autocodenode.labelOverride || '',
      isLabelUpdated: autocodenode.useLabelOverride || false,
      dataSmartSearch: {
        autocodenode,
      },
    };
  });
  return targetData;
};

export const _validateEditTarget = (originalTarget, tempTarget) => {
  if (
    originalTarget.tn !== tempTarget.name ||
    originalTarget.ex !== tempTarget.expr ||
    originalTarget.wt !== tempTarget.wt ||
    originalTarget.sn !== tempTarget.study ||
    originalTarget.pn !== tempTarget.pn
  ) {
    return true;
  }
  return false;
};

export const _resetTargetLabel = (targetData, importValidations, folderId) => {
  let selectedFolderErrorData = cloneDeep(importValidations[folderId].errors);
  let selectedFolderValidData = cloneDeep(importValidations[folderId].valid);
  const duplicateTargetList = cloneDeep(
    importValidations[folderId].duplicateTargetList
  );
  if (
    !selectedFolderValidData.includes(targetData.ui) &&
    !duplicateTargetList.includes(targetData.ui)
  ) {
    selectedFolderValidData = [...selectedFolderValidData, targetData.ui];
  }
  if (
    selectedFolderErrorData.includes(targetData.ui) &&
    !duplicateTargetList.includes(targetData.ui)
  ) {
    selectedFolderErrorData = selectedFolderErrorData.filter(
      def => def !== targetData.ui
    );
  }
  return {
    errors: selectedFolderErrorData,
    valid: selectedFolderValidData,
    duplicateTargetList,
  };
};

export const _getUpdatedListForBuild = selectedList => {
  const finalListForSave = [];
  selectedList.forEach(target => {
    if (!target.isFailed && !target.isDuplicate) {
      finalListForSave.push(target);
    }
  });
  return finalListForSave;
};

export const _validateDuplicateTarget = (targetList, targetRow) => {
  const duplicateTarget = targetList.filter(
    row =>
      row.tn.toLowerCase() === targetRow.tn.toLowerCase() &&
      row.wt === targetRow.wt &&
      row.pn === targetRow.pn
  );
  return duplicateTarget;
};
